import { useMemo } from 'react';
import { ListingsV2QueryProps } from 'types/listings';
import { ListingsV3QueryProps } from 'types/listingV3';
import { normalizeListingV2, normalizeListingV3 } from 'utils/listingsHelpers';
import useListingsV3 from 'api/listing/useListingsV3/useListingsV3';
import useListingsV2 from './useListingsV2';

type UseListingsProps = {
  v2Params: ListingsV2QueryProps;
  v3Params: ListingsV3QueryProps;
};

const useListings = ({ v2Params, v3Params }: UseListingsProps) => {
  const hasDateFiltering = v2Params?.from || v2Params?.to;
  const useV3 = !hasDateFiltering;

  const v2 = useListingsV2({ skip: useV3, ...v2Params });
  const v3 = useListingsV3({ skip: !useV3, ...v3Params });

  const listings = useMemo(
    () =>
      useV3
        ? v3.listings.map(normalizeListingV3)
        : v2.listings.map(normalizeListingV2),
    [useV3, v2.listings, v3.listings],
  );

  const result = useV3 ? v3 : v2;

  return {
    ...result,
    listings,
    isV3: useV3,
  };
};

export default useListings;
